"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TeacherStatusEnum = void 0;
/** Статус преподавателя */
var TeacherStatusEnum;
(function (TeacherStatusEnum) {
  /** Не преподаватель */
  TeacherStatusEnum[TeacherStatusEnum["not_teacher"] = 0] = "not_teacher";
  /** Не верифицированный преподаватель */
  TeacherStatusEnum[TeacherStatusEnum["not_verified"] = 1] = "not_verified";
  /**
   * Верифицированный преподаватель
   *
   * @deprecated
   */
  TeacherStatusEnum[TeacherStatusEnum["verified"] = 2] = "verified";
  /** Репетитор с ограничениями */
  TeacherStatusEnum[TeacherStatusEnum["limited_tutor"] = 2] = "limited_tutor";
  /** Репетитор */
  TeacherStatusEnum[TeacherStatusEnum["tutor"] = 3] = "tutor";
  /** Преподаватель */
  TeacherStatusEnum[TeacherStatusEnum["teacher"] = 4] = "teacher";
  /** Преподаватель с ограничениями */
  TeacherStatusEnum[TeacherStatusEnum["limited_teacher"] = 5] = "limited_teacher";
})(TeacherStatusEnum = exports.TeacherStatusEnum || (exports.TeacherStatusEnum = {}));
